import { render, staticRenderFns } from "./ReportsClientNotificationView.vue?vue&type=template&id=43302993"
import script from "./ReportsClientNotificationView.vue?vue&type=script&lang=ts"
export * from "./ReportsClientNotificationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports